document.addEventListener('DOMContentLoaded', function () {
	setupCustomNewsletterForm();
	setupCiviNewsletterTurnstile();

	function setupCustomNewsletterForm() {
		var form = document.querySelector('.js-newsletter-form');
		if (!form) {
			return;
		}
		var msg = document.getElementById('newsletter-signup-message');
		form.addEventListener('submit', function (e) {
			e.preventDefault();
			msg.textContent = '';
			var email = form.email.value;
			var firstNameField = form.querySelector('[name="first_name"]');
			var lastNameField = form.querySelector('[name="last_name"]');
			var companyNameField = form.querySelector('[name="company_name"]');
			var phoneNumberField = form.querySelector('[name="phone_number"]');
			var turnstileResponse = document.querySelector('[name="cf-turnstile-response"]');
			var first_name = firstNameField ? firstNameField.value : '';
			var last_name = lastNameField ? lastNameField.value : '';
			var company_name = companyNameField ? companyNameField.value : '';
			var phone_number = phoneNumberField ? phoneNumberField.value : '';
			var turnstile_response = turnstileResponse ? turnstileResponse.value : '';
			if (!email) {
				msg.textContent = 'Please enter your email.';
				msg.className = 'custom-newsletter__msg--error';
				return;
			}
			var xhr = new XMLHttpRequest();
			xhr.open('POST', (typeof bmNewsletterForm !== 'undefined' ? bmNewsletterForm.ajaxUrl : '/wp-admin/admin-ajax.php'));
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
			xhr.onload = function () {
				try {
					var resp = JSON.parse(xhr.responseText);
					var message = (resp.data && resp.data.message) ? resp.data.message : resp.data;
					if (resp.success) {
						msg.textContent = message;
						msg.className = 'custom-newsletter__msg--success';
						form.reset();
					} else {
						msg.textContent = message || 'Error. Please try again.';
						msg.className = 'custom-newsletter__msg--error';
					}
				} catch (e) {
					msg.textContent = 'Unexpected error.';
					msg.className = 'custom-newsletter__msg--error';
				}
			};
			var params = 'action=bm_newsletter_signup&email=' + encodeURIComponent(email);
			if (firstNameField) {
				params += '&first_name=' + encodeURIComponent(first_name);
			}
			if (lastNameField) {
				params += '&last_name=' + encodeURIComponent(last_name);
			}
			if (companyNameField) {
			params += '&company_name=' + encodeURIComponent(company_name);
		}
		if (phoneNumberField) {
			params += '&phone_number=' + encodeURIComponent(phone_number);
		}
			if (turnstileResponse) {
				params += '&turnstile_response=' + encodeURIComponent(turnstile_response);
			}
			xhr.send(params);
		});
	}

	function setupCiviNewsletterTurnstile() {
		document.addEventListener('click', onCiviSubmitClick, true);

		if (window.CRM && window.CRM.$) {
			window.CRM.$(document).on('crmFormSuccess', 'af-form', function (event) {
				var widget = getTurnstileWidgetForElement(event.currentTarget);
				if (widget) {
					widget.style.display = 'none';
				}
			});
		}
	}

	function onCiviSubmitClick(event) {
		var button = event.target.closest('button[ng-click="afform.submit()"]');
		if (!button) {
			return;
		}

		var section = button.closest('.newsletter-signup');
		if (!section) {
			return;
		}

		var widget = section.querySelector('.js-newsletter-civi-turnstile');
		if (!widget) {
			return;
		}

		var afform = button.closest('af-form');
		if (!afform) {
			return;
		}

		var turnstileField = afform.querySelector('input[name="newsletter_turnstile"]');
		if (!turnstileField) {
			return;
		}

		var token = getTurnstileToken(widget);
		// Write directly into the Afform controller model before submit serialization runs.
		setAngularTurnstileValue(afform, token);
		// Keep the hidden field in sync with the model for template/debug visibility.
		setFieldValue(turnstileField, token);
	}

	function getTurnstileWidgetForElement(element) {
		var section = element ? element.closest('.newsletter-signup') : null;
		return section ? section.querySelector('.js-newsletter-civi-turnstile') : null;
	}

	function setAngularTurnstileValue(afform, value) {
		if (!window.angular) {
			return;
		}

		var scope = window.angular.element(afform).scope();
		if (!scope || !scope.afform || typeof scope.afform.getData !== 'function') {
			return;
		}

		var updateValue = function () {
			var extra = scope.afform.getData('extra') || {};
			extra.newsletter_turnstile = value;
		};

		if (scope.$root && scope.$root.$$phase) {
			updateValue();
			return;
		}

		scope.$apply(updateValue);
	}

	function setFieldValue(field, value) {
		// Mirror the model value onto the DOM field used by the template.
		field.value = value;
		field.setAttribute('value', value);
		field.dispatchEvent(new Event('input', { bubbles: true }));
		field.dispatchEvent(new Event('change', { bubbles: true }));
	}

	function getTurnstileToken(widget) {
		var responseField = widget.querySelector('[name="cf-turnstile-response"]');
		return responseField ? responseField.value : '';
	}

});
